document.addEventListener('DOMContentLoaded', function () {

  // --- TAB SWITCHING ---
  const tabs = document.querySelectorAll('.size-tab');
  const contents = document.querySelectorAll('.size-content');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      // Remove active from all tabs
      tabs.forEach(t => t.classList.remove('active'));
      // Add active to clicked tab
      tab.classList.add('active');

      // Hide all content
      contents.forEach(c => c.classList.remove('active'));
      // Show the one that matches clicked tab
      const target = document.getElementById(tab.dataset.tab);
      if (target) target.classList.add('active');
    });
  });

  // --- CM/INCH TOGGLE ---
  const unitButtons = document.querySelectorAll('.unit-btn');
  const measurementCells = document.querySelectorAll('#measurements td[data-cm]');

  unitButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Remove active from all buttons
      unitButtons.forEach(b => b.classList.remove('active'));
      // Add active to clicked
      btn.classList.add('active');

      const unit = btn.dataset.unit;

      measurementCells.forEach(cell => {
        const cm = parseFloat(cell.dataset.cm);
        if (unit === 'cm') {
          cell.textContent = cm.toFixed(1);
        } else {
          const inch = cm / 2.54;
          cell.textContent = inch.toFixed(1);
        }
      });
    });
  });

});